import ActionTypes from "./ActionTypes";
import Dispatcher from "./Dispatcher";

export default {
  getAllTerms() {
    Dispatcher.dispatch({
      actionType: ActionTypes.GLOSSARY_GET_ALL_TERMS
    });
  },
  getTermById(id){
    Dispatcher.dispatch({
      actionType: ActionTypes.GLOSSARY_GET_TERM,
      id: id,
    })
  },
  updateFilter(filter){
    Dispatcher.dispatch({
      actionType: ActionTypes.GLOSSARY_UPDATE_FILTER,
      filter
    });
  },
  updateLetterRange(letterRange){
    Dispatcher.dispatch({
      actionType: ActionTypes.GLOSSARY_UPDATE_LETTER_RANGE,
      letterRange
    });
  },
  viewGlossaryTerm(id) {
    Dispatcher.dispatch({
      actionType: ActionTypes.GLOSSARY_VIEW_TERM,
      glossaryId: id
    })
  }
}
